<template>
  <div class="element-autocomplete">
    <div class="container">
      <ul>
        <li v-for="(item, index) in items" @click="selectItem(item, index)"  :key="index">
          <div v-if="item.splited_texts">
            <template v-for="(txt, tidx) in item.splited_texts">
              <span>{{txt}}</span>
              <span v-if="tidx != item.splited_texts.length - 1" class="highlight">{{item.searchText.toUpperCase()}}</span>
            </template>
            
          </div>
          <span v-if="item.optional_text" class="optional-txt">
            <span>{{item.optional_text}}</span>만원
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .element-autocomplete > .container ul li > div {
    display: inline-block;
    width: 75%;
    @include cl;
  }
  .highlight {
    color: $color-schema;
    font-weight: bold;
  }
  .optional-txt {
    float: right;
    & > span {
      color: #5dc845;
      padding-right: 0.1rem;
    }
  }
</style>
<script>
export default {
  props: [ "status", "items" ],
  data(){
    return {
    }
  },
  methods: {
    selectItem( value, index ) {
      this.$emit("clickItem", { value, index })
    }
  }
}
</script>
